import { listEntradasVisibles, insertBusqueda } from '../infrastructure/faq.repository.js';
import { esConsultaRegistrable } from '../shared/faq-search-policy.js';

/**
 * Staff side of the FAQ (openspec/changes/staff-faq/spec.md B1, B3, B4): reads
 * the visible entries and records failed searches. Translates repository
 * throws into `{ ok, kind, mensaje }`, like the other panel services — a raw
 * Postgres code never reaches the UI.
 */

export const GENERIC_ERROR_MESSAGE = 'Ocurrió un error. Probá de nuevo.';

/** `faq_busquedas.consulta` is limited to 200 characters by migration 30. */
const MAX_CONSULTA = 200;

/**
 * @returns {Promise<{ ok: true, entradas: Array<Record<string, any>> } | { ok: false, kind: 'error', mensaje: string }>}
 */
export async function loadEntradasVisibles() {
    try {
        return { ok: true, entradas: await listEntradasVisibles() };
    } catch (err) {
        window.Sentry?.captureException(err);
        return { ok: false, kind: 'error', mensaje: GENERIC_ERROR_MESSAGE };
    }
}

/**
 * Records a failed search: `sin_resultado` (finished search with 0 results,
 * B3) or `no_encontre` (the employee's report button, B4).
 * @param {string} consulta
 * @param {'sin_resultado' | 'no_encontre'} tipo
 * @returns {Promise<{ ok: true } | { ok: false, kind: 'validacion' | 'error', mensaje: string }>}
 */
export async function registrarBusqueda(consulta, tipo) {
    // The 3-character minimum is B3's (automatic recording); a report the
    // employee sends on purpose (B4) only needs text, as the database does.
    const valida = tipo === 'sin_resultado' ? esConsultaRegistrable(consulta) : String(consulta ?? '').trim() !== '';
    if (!valida) {
        return { ok: false, kind: 'validacion', mensaje: 'La búsqueda es demasiado corta.' };
    }
    try {
        await insertBusqueda({ consulta: consulta.trim().slice(0, MAX_CONSULTA), tipo });
        return { ok: true };
    } catch (err) {
        window.Sentry?.captureException(err);
        return { ok: false, kind: 'error', mensaje: GENERIC_ERROR_MESSAGE };
    }
}
